import { cn } from '@/lib/utils';

export type IB22DotProps = {
    count: number;
    color: string;
    className?: string;
};

export function IB22Dot({ count, color, className }: IB22DotProps) {
    return (
        <div
            className={cn(
                'flex min-h-8 min-w-8 h-8 w-8 items-center justify-center rounded-full text-white',
                className,
            )}
            style={{ background: color }}
        >
            <p>{count}</p>
        </div>
    );
}
